// import React from 'react';
import { Column } from '@tanstack/react-table'; // Header
import { useTranslation } from 'react-i18next';
import { Filter, ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';
import { ColumnConfig } from '@/types/table.types';

interface TableHeaderProps<T> {
  header: Column<T, unknown>;
  columnConfig: ColumnConfig<T>;
  onFilterClick: (columnId: string) => void;
  isFiltered: boolean;
  justifyHeader?: boolean;
}

export const TableHeader = <T extends object>({
  header,
  columnConfig,
  onFilterClick,
  isFiltered,
  justifyHeader = false,
}: TableHeaderProps<T>) => {
  const { t } = useTranslation();
  const sorted = header.getIsSorted();
  const justifyClass = justifyHeader ? 'justify-center' : '';
  return (
    <div className={`flex items-center ${justifyClass}`}>
      <span
        className="cursor-pointer select-none flex items-center"
        onClick={header.getToggleSortingHandler()}
      >
        {t(columnConfig.header)}
        {sorted === 'asc' && <ArrowUp className="w-4 h-4" />}
        {sorted === 'desc' && <ArrowDown className="w-4 h-4" />}
        {!sorted && <ArrowUpDown className="w-4 h-4 text-gray-400" />}
      </span>
      {columnConfig.enableFilter && (
        <button
          type="button"
          className={`ml-1 p-1 rounded ${isFiltered ? 'bg-brand-orange/20 text-brand-orange' : 'text-gray-300 hover:text-brand-orange'}`}
          onClick={(e) => {
            e.stopPropagation();
            onFilterClick(header.id);
          }}
          aria-label={t('common.filter')}
        >
          <Filter className="w-4 h-4" fill={isFiltered ? 'currentColor' : 'none'} />
        </button>
      )}
    </div>
  );
};
